module.exports = __webpack_public_path__ + "static/desktop/img/case1.3bdec83b.jpg";